// Question texts come from the API with basic formatting tags (e.g. "<B>...</B>").
// Escape everything, then re-enable only attribute-less formatting tags, so the
// result is safe for v-html on this public page.
const FORMATTING_TAGS = /&lt;(\/?)(b|strong|i|em|u|br)\s*\/?&gt;/gi;

export function questionTextHtml(text) {
    return String(text == null ? '' : text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(FORMATTING_TAGS, (match, slash, tag) => '<' + slash + tag.toLowerCase() + '>');
}
